import { useId } from "react";
import { FieldHint, FieldLabel, fieldClass } from "./Field";

/* Figma "Text view": the multi-line Text field, 120 tall, with 12 / 16 padding. */
const TextView = ({ label, hint, id, className = "", ...textareaProps }) => {
  const autoId = useId();
  const inputId = id || autoId;
  return (
    <div className={`flex w-full flex-col gap-[6px] ${className}`}>
      {label && <FieldLabel htmlFor={inputId}>{label}</FieldLabel>}
      <div className={fieldClass({ height: "h-[120px]", className: "px-space-16 py-space-12" })}>
        <textarea
          id={inputId}
          className="relative h-full w-full resize-none bg-transparent text-callout text-label-primary outline-none placeholder:text-label-tertiary"
          {...textareaProps}
        />
      </div>
      {hint && <FieldHint>{hint}</FieldHint>}
    </div>
  );
};

export default TextView;
